import axios from 'axios';
import Utils from 'utils/Utils';
import { getPlatform, DEVICE_OS } from '../components/card/cardUtils';

export const trackError = data => {
  const profile = {};
  if (data.userdata) {
    const savedProfile = JSON.parse(data.userdata);
    profile.userid = savedProfile.user_id;
    profile.username = savedProfile.username;
  }

  const body = {
    logs: [
      {
        application: {
          platform: 'Web',
          version: '4.4.18',
        },
        cdn: {
          node: 'a184-28-221-102.deploy.akamaitechnologies.com',
          'X-Cache': 'default',
          'X-Cache-Key': 'default',
        },
        device: {
          deviceid: 'web',
          brand: DEVICE_OS[getPlatform()],
          os: Utils.getDeviceOS(),
          kind: 'html5',
          model: 'html5',
          ip: '201.116.78.2',
        },
        operator: {
          operatorKey: 'error',
          status: 0,
          request: '',
          faildata: {
            msg: 'undefined hks',
          },
        },
        servername: 'default',
        time: data.date,
        user: {
          userid: profile.userid || '0',
          username: profile.username || 'anonymous',
          email: 'anonymous',
          hks: 'undefined',
          userhash: data.userhash || '',
          region: data.region || '',
        },
      },
    ],
  };
  axios.post('https://dashboard-producer.clarovideo.net/send', body);
};
